export default "__VITE_ASSET__642cd380__"